import { render, staticRenderFns } from "./EaducationItem.vue?vue&type=template&id=f1dc49d2&"
import script from "./EaducationItem.vue?vue&type=script&lang=js&"
export * from "./EaducationItem.vue?vue&type=script&lang=js&"
import style0 from "./EaducationItem.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports